// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.credit-link {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  color: #4a5568;
  text-decoration: none;
  font-size: 14px;
}

.credit-link:hover {
  text-decoration: underline;
}

.App {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f7f7f8;
  color: #333;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

.playground {
  display: flex;
  width: 90%;
  max-width: 1400px;
  height: 90vh;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
}

.editor-panel {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-right: 1px solid #e5e5e5;
}

.settings-panel {
  width: 300px; /* Increased from 300px to 330px (10% wider) */
  padding: 20px;
  background-color: #f0f2f5;
  overflow-y: auto;
}

.settings-panel h1 {
  font-size: 20px;
  margin-bottom: 20px;
  color: #333;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 10px;
}

.settings-panel input[type="password"],
.settings-panel input[type="text"] {
  width: 95%;
  padding: 10px;
  margin-bottom: 20px; /* Increased from 15px to 20px */
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.3s;
}

.settings-panel input[type="password"]:focus,
.settings-panel input[type="text"]:focus {
  border-color: #40a9ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  outline: none;
}

.slider-container {
  margin-bottom: 25px; /* Increased from 20px to 25px */
}

.slider-container label {
  display: flex;
  flex-direction: column; /* Changed to column for better layout */
  font-size: 14px;
  margin-bottom: 8px;
  color: #333;
}

.slider-container label span {
  margin-bottom: 5px; /* Add some space between label text and slider */
}

.slider-container input[type="range"] {
  width: 100%;
  -webkit-appearance: none;
  height: 6px;
  background: #d3d3d3;
  outline: none;
  border-radius: 3px;
  margin-top: 5px; /* Add some space above the slider */
}

.slider-container input[type="range"]::-webkit-slider-thumb {
  appearance: none;
  width: 18px;
  height: 18px;
  background: #40a9ff;
  cursor: pointer;
  border-radius: 50%;
}

.slider-container input[type="range"]::-moz-range-thumb {
  width: 18px;
  height: 18px;
  background: #40a9ff;
  cursor: pointer;
  border-radius: 50%;
}

.stop-tokens-container {
  margin-bottom: 25px; /* Increased from 20px to 25px */
}

.stop-tokens-container label {
  display: block;
  font-size: 14px;
  margin-bottom: 8px;
  color: #333;
}

.stop-tokens-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}

.stop-token {
  background-color: #f0f0f0;
  border-radius: 3px;
  padding: 4px 8px; /* Increased padding for better visibility */
  font-size: 12px;
  display: flex;
  align-items: center;
}

.stop-token button {
  background: none;
  border: none;
  color: #999;
  font-size: 14px;
  cursor: pointer;
  padding: 0 0 0 5px;
  margin: 0;
}

.stop-token button:hover {
  color: #003a8c;
}

h1 {
  font-size: 24px;
  margin-bottom: 20px;
  color: #202123;
}

.editor-container {
  flex-grow: 1;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  background-color: #ffffff;
  overflow-y: auto;
  margin-bottom: 20px;
}

.DraftEditor-root {
  height: 100%;
  padding: 10px;
  font-size: 16px;
}

.public-DraftEditorPlaceholder-root {
  color: #6e6e80;
}

input[type="password"],
input[type="text"] {
  width: 100%;
  padding: 8px;
  margin-bottom: 15px;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  font-size: 14px;
}

.slider-container {
  margin-bottom: 15px;
}

.slider-container label {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  margin-bottom: 5px;
}

.slider-container input[type="range"] {
  width: 100%;
}

.stop-tokens-container {
  margin-bottom: 15px;
}

.stop-tokens-list {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 5px;
}

.stop-token {
  background-color: #f0f0f0;
  border-radius: 3px;
  padding: 2px 5px;
  font-size: 12px;
  display: flex;
  align-items: center;
}

.stop-token button {
  background: none;
  border: none;
  color: #999;
  font-size: 14px;
  cursor: pointer;
  padding: 0 0 0 5px;
  margin: 0;
}

.button-container {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 25px; /* Increased from 20px to 25px */
}

button {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s;
}

button[type="submit"] {
  background-color: #10a37f;
  color: white;
}

button[type="submit"]:hover {
  background-color: #1a7f64;
}

button[type="submit"]:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.stop-button {
  background-color: #ff4d4f;
  color: white;
}

.stop-button:hover {
  background-color: #ff7875;
}

.remove-button {
  background-color: #f0f0f0;
  color: #333;
}

.remove-button:hover {
  background-color: #e0e0e0;
}

.error-message {
  color: #ff4d4f;
  font-size: 14px;
  margin-top: 10px;
}

.generated-text {
  background-color: #f0fff4;
}

.api-key-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.api-key-popup {
  background-color: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  width: 90%;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.api-key-popup h2 {
  color: #2c5282;
  margin-bottom: 1rem;
}

.api-key-popup p {
  color: #4a5568;
  margin-bottom: 1.5rem;
}

.api-key-popup form {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.api-key-popup input[type="password"] {
  width: 100%;
  padding: 0.75rem;
  margin-bottom: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  font-size: 1rem;
  transition: border-color 0.3s ease;
}

.api-key-popup input[type="password"]:focus {
  border-color: #4299e1;
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);
  outline: none;
}

.api-key-popup .primary-button {
  background-color: #4299e1;
  color: white;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
  width: 100%;
  max-width: 200px;
}

.api-key-popup .primary-button:hover {
  background-color: #3182ce;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,8JAA8J;AAChK;;AAEA;EACE,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,YAAY,EAAE,8CAA8C;EAC5D,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;;EAEE,UAAU;EACV,aAAa;EACb,mBAAmB,EAAE,gCAAgC;EACrD,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;;EAEE,qBAAqB;EACrB,6CAA6C;EAC7C,aAAa;AACf;;AAEA;EACE,mBAAmB,EAAE,gCAAgC;AACvD;;AAEA;EACE,aAAa;EACb,sBAAsB,EAAE,wCAAwC;EAChE,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB,EAAE,iDAAiD;AACvE;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,eAAe,EAAE,oCAAoC;AACvD;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB,EAAE,gCAAgC;AACvD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB,EAAE,4CAA4C;EAC9D,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB,EAAE,gCAAgC;AACpD;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;EACtC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".credit-link {\n  position: absolute;\n  top: 10px;\n  left: 50%;\n  transform: translateX(-50%);\n  color: #4a5568;\n  text-decoration: none;\n  font-size: 14px;\n}\n\n.credit-link:hover {\n  text-decoration: underline;\n}\n\n.App {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background-color: #f7f7f8;\n  color: #333;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\n.playground {\n  display: flex;\n  width: 90%;\n  max-width: 1400px;\n  height: 90vh;\n  background-color: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);\n}\n\n.editor-panel {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  padding: 20px;\n  border-right: 1px solid #e5e5e5;\n}\n\n.settings-panel {\n  width: 300px; /* Increased from 300px to 330px (10% wider) */\n  padding: 20px;\n  background-color: #f0f2f5;\n  overflow-y: auto;\n}\n\n.settings-panel h1 {\n  font-size: 20px;\n  margin-bottom: 20px;\n  color: #333;\n  border-bottom: 1px solid #e0e0e0;\n  padding-bottom: 10px;\n}\n\n.settings-panel input[type=\"password\"],\n.settings-panel input[type=\"text\"] {\n  width: 95%;\n  padding: 10px;\n  margin-bottom: 20px; /* Increased from 15px to 20px */\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  font-size: 14px;\n  transition: border-color 0.3s;\n}\n\n.settings-panel input[type=\"password\"]:focus,\n.settings-panel input[type=\"text\"]:focus {\n  border-color: #40a9ff;\n  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);\n  outline: none;\n}\n\n.slider-container {\n  margin-bottom: 25px; /* Increased from 20px to 25px */\n}\n\n.slider-container label {\n  display: flex;\n  flex-direction: column; /* Changed to column for better layout */\n  font-size: 14px;\n  margin-bottom: 8px;\n  color: #333;\n}\n\n.slider-container label span {\n  margin-bottom: 5px; /* Add some space between label text and slider */\n}\n\n.slider-container input[type=\"range\"] {\n  width: 100%;\n  -webkit-appearance: none;\n  height: 6px;\n  background: #d3d3d3;\n  outline: none;\n  border-radius: 3px;\n  margin-top: 5px; /* Add some space above the slider */\n}\n\n.slider-container input[type=\"range\"]::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 18px;\n  height: 18px;\n  background: #40a9ff;\n  cursor: pointer;\n  border-radius: 50%;\n}\n\n.slider-container input[type=\"range\"]::-moz-range-thumb {\n  width: 18px;\n  height: 18px;\n  background: #40a9ff;\n  cursor: pointer;\n  border-radius: 50%;\n}\n\n.stop-tokens-container {\n  margin-bottom: 25px; /* Increased from 20px to 25px */\n}\n\n.stop-tokens-container label {\n  display: block;\n  font-size: 14px;\n  margin-bottom: 8px;\n  color: #333;\n}\n\n.stop-tokens-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 10px;\n}\n\n.stop-token {\n  background-color: #f0f0f0;\n  border-radius: 3px;\n  padding: 4px 8px; /* Increased padding for better visibility */\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n}\n\n.stop-token button {\n  background: none;\n  border: none;\n  color: #999;\n  font-size: 14px;\n  cursor: pointer;\n  padding: 0 0 0 5px;\n  margin: 0;\n}\n\n.stop-token button:hover {\n  color: #003a8c;\n}\n\nh1 {\n  font-size: 24px;\n  margin-bottom: 20px;\n  color: #202123;\n}\n\n.editor-container {\n  flex-grow: 1;\n  border: 1px solid #e5e5e5;\n  border-radius: 4px;\n  background-color: #ffffff;\n  overflow-y: auto;\n  margin-bottom: 20px;\n}\n\n.DraftEditor-root {\n  height: 100%;\n  padding: 10px;\n  font-size: 16px;\n}\n\n.public-DraftEditorPlaceholder-root {\n  color: #6e6e80;\n}\n\ninput[type=\"password\"],\ninput[type=\"text\"] {\n  width: 100%;\n  padding: 8px;\n  margin-bottom: 15px;\n  border: 1px solid #e5e5e5;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.slider-container {\n  margin-bottom: 15px;\n}\n\n.slider-container label {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 14px;\n  margin-bottom: 5px;\n}\n\n.slider-container input[type=\"range\"] {\n  width: 100%;\n}\n\n.stop-tokens-container {\n  margin-bottom: 15px;\n}\n\n.stop-tokens-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n  margin-top: 5px;\n}\n\n.stop-token {\n  background-color: #f0f0f0;\n  border-radius: 3px;\n  padding: 2px 5px;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n}\n\n.stop-token button {\n  background: none;\n  border: none;\n  color: #999;\n  font-size: 14px;\n  cursor: pointer;\n  padding: 0 0 0 5px;\n  margin: 0;\n}\n\n.button-container {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  margin-top: 25px; /* Increased from 20px to 25px */\n}\n\nbutton {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\nbutton[type=\"submit\"] {\n  background-color: #10a37f;\n  color: white;\n}\n\nbutton[type=\"submit\"]:hover {\n  background-color: #1a7f64;\n}\n\nbutton[type=\"submit\"]:disabled {\n  background-color: #cccccc;\n  cursor: not-allowed;\n}\n\n.stop-button {\n  background-color: #ff4d4f;\n  color: white;\n}\n\n.stop-button:hover {\n  background-color: #ff7875;\n}\n\n.remove-button {\n  background-color: #f0f0f0;\n  color: #333;\n}\n\n.remove-button:hover {\n  background-color: #e0e0e0;\n}\n\n.error-message {\n  color: #ff4d4f;\n  font-size: 14px;\n  margin-top: 10px;\n}\n\n.generated-text {\n  background-color: #f0fff4;\n}\n\n.api-key-popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.api-key-popup {\n  background-color: white;\n  padding: 2rem;\n  border-radius: 8px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  max-width: 400px;\n  width: 90%;\n  text-align: center;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.api-key-popup h2 {\n  color: #2c5282;\n  margin-bottom: 1rem;\n}\n\n.api-key-popup p {\n  color: #4a5568;\n  margin-bottom: 1.5rem;\n}\n\n.api-key-popup form {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.api-key-popup input[type=\"password\"] {\n  width: 100%;\n  padding: 0.75rem;\n  margin-bottom: 1rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 4px;\n  font-size: 1rem;\n  transition: border-color 0.3s ease;\n}\n\n.api-key-popup input[type=\"password\"]:focus {\n  border-color: #4299e1;\n  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);\n  outline: none;\n}\n\n.api-key-popup .primary-button {\n  background-color: #4299e1;\n  color: white;\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 4px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  width: 100%;\n  max-width: 200px;\n}\n\n.api-key-popup .primary-button:hover {\n  background-color: #3182ce;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
